import React, { useState } from "react";
import { Col, Container, Form, Input, Label, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { Btn, H2, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import { ResetPasswordText } from "../../utils/Constant";
import { toast } from "react-toastify";
import { usePasswordReset } from "./useAuth";

export default function ResetPassword() {
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [show, setShow] = useState(false);

  const resetPassword = usePasswordReset();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("New Password and Confirm Password do not match");
      return;
    } else {
      resetPassword.mutate(
        {
            otp,
            new_password: newPassword,
            confirm_password: confirmPassword,
          },
         // Pass credentials as an object


        {
          onError: (error) => {
            console.error("reset failed:", error);
          },
        }
      );
    }

    // Call API to reset password here
    // console.log({ otp, newPassword, confirmPassword });

    // Navigate or show success message
  };

  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xs="12" className="p-0">
          <div className="login-card login-dark">
            <div>
              <div>
                <Link className="logo text-center" to="#">
                  <Image
                    style={{ width: "25%" }}
                    src={dynamicImage("logo/Truesales.png")}
                    alt="logo"
                  />
                </Link>
              </div>
              <div className="login-main">
                <Form className="theme-form" onSubmit={handleSubmit}>
                  <H2 className="text-center">{ResetPasswordText}</H2>
                  <P className="text-center">
                    {"Enter OTP and set a new password"}
                  </P>

                  {/* OTP Field */}
                  <div className="form-group">
                    <Label className="col-form-label">OTP</Label>
                    <Input
                      type="text"
                      required
                      placeholder="Enter OTP"
                      value={otp}
                      onChange={(event) => setOtp(event.target.value)}
                    />
                  </div>

                  {/* New Password Field */}
                  <div className="form-group">
                    <Label className="col-form-label">New Password</Label>
                    <div className="form-input position-relative">
                      <Input
                        type={show ? "text" : "password"}
                        placeholder="Enter New Password"
                        onChange={(event) => setNewPassword(event.target.value)}
                        value={newPassword}
                      />
                      <div className="show-hide" onClick={() => setShow(!show)}>
                        <span className="show"> </span>
                      </div>
                    </div>
                  </div>

                  {/* Confirm Password Field */}
                  <div className="form-group">
                    <Label className="col-form-label">Confirm Password</Label>
                    <div className="form-input position-relative">
                      <Input
                        type={show ? "text" : "password"}
                        placeholder="Enter Confirm Password"
                        onChange={(event) =>
                          setConfirmPassword(event.target.value)
                        }
                        value={confirmPassword}
                      />
                      <div className="show-hide" onClick={() => setShow(!show)}>
                        <span className="show"> </span>
                      </div>
                    </div>
                  </div>

                  <div className="text-end mt-3">
                    <Btn color="primary" block className="w-100">
                      {ResetPasswordText}
                    </Btn>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
